"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _nicbaseForms = require("nicbase-forms");

var _Picker = _interopRequireDefault(require("nicbase-rc-calendar/lib/Picker"));

var _RangeCalendar = _interopRequireDefault(require("nicbase-rc-calendar/lib/RangeCalendar"));

var _Panel = _interopRequireDefault(require("nicbase-rc-time-picker/lib/Panel"));

var _locales = _interopRequireDefault(require("../locales"));

var _dateRangeFooter = _interopRequireDefault(require("./date-range-footer"));

var _rangeTemplates = _interopRequireDefault(require("./range-templates"));

require("nicbase-rc-calendar/assets/index.css");

require("nicbase-rc-time-picker/assets/index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DateRangePicker = function DateRangePicker(_ref) {
  var inputLabel = _ref.inputLabel,
      hideLabel = _ref.hideLabel,
      locale = _ref.locale,
      timezone = _ref.timezone,
      from = _ref.from,
      until = _ref.until,
      onChange = _ref.onChange,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      enableTime = _ref.enableTime,
      enableRangeTemplates = _ref.enableRangeTemplates,
      rangeTemplates = _ref.rangeTemplates,
      enabledDate = _ref.enabledDate,
      disabled = _ref.disabled,
      isFilterFlyOut = _ref.isFilterFlyOut;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(from && _momentTimezone["default"].tz((0, _momentTimezone["default"])(from).locale(locale), timezone)),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedFrom = _useState4[0],
      setSelectedFrom = _useState4[1];

  var _useState5 = (0, _react.useState)(from && _momentTimezone["default"].tz((0, _momentTimezone["default"])(from).locale(locale), timezone)),
      _useState6 = _slicedToArray(_useState5, 2),
      visibleFrom = _useState6[0],
      setVisibleFrom = _useState6[1];

  var _useState7 = (0, _react.useState)(until && _momentTimezone["default"].tz((0, _momentTimezone["default"])(until).locale(locale), timezone)),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedUntil = _useState8[0],
      setSelectedUntil = _useState8[1];

  var _useState9 = (0, _react.useState)(until && _momentTimezone["default"].tz((0, _momentTimezone["default"])(until).locale(locale), timezone)),
      _useState10 = _slicedToArray(_useState9, 2),
      visibleUntil = _useState10[0],
      setVisibleUntil = _useState10[1]; // handle change of from and until in props


  var prevFrom = (0, _hooks.usePrevious)(from);
  var prevUntil = (0, _hooks.usePrevious)(until);
  (0, _hooks.useDidUpdate)(function () {
    if (prevFrom !== from && (!selectedFrom || selectedFrom && !selectedFrom.isSame(from))) {
      var newFrom = from && _momentTimezone["default"].tz((0, _momentTimezone["default"])(from).locale(locale), timezone);

      setSelectedFrom(newFrom);
      setVisibleFrom(newFrom);
    }

    if (prevUntil !== until && (!selectedUntil || selectedUntil && !selectedUntil.isSame(until))) {
      var newUntil = until && _momentTimezone["default"].tz((0, _momentTimezone["default"])(until).locale(locale), timezone);

      setSelectedUntil(newUntil);
      setVisibleUntil(newUntil);
    }
  }, [from, locale, prevFrom, prevUntil, selectedFrom, selectedUntil, timezone, until]); // handle range selection change

  var prevSelectedFrom = (0, _hooks.usePrevious)(selectedFrom);
  var prevSelectedUntil = (0, _hooks.usePrevious)(selectedUntil);
  (0, _hooks.useDidUpdate)(function () {
    // both range values must be set before onChange is called
    if (selectedFrom && !selectedUntil || !selectedFrom && selectedUntil) {
      return;
    }

    if (selectedFrom === visibleFrom && selectedUntil === visibleUntil) {
      var newFrom = null;
      var newUntil = null;
      var rangeChanged = false;

      if (prevSelectedFrom !== selectedFrom) {
        rangeChanged = true;
        newFrom = (selectedFrom === null || selectedFrom === void 0 ? void 0 : selectedFrom.toDate()) || null;
      } else {
        newFrom = (prevSelectedFrom === null || prevSelectedFrom === void 0 ? void 0 : prevSelectedFrom.toDate()) || null;
      }

      if (prevSelectedUntil !== selectedUntil) {
        rangeChanged = true;
        newUntil = (selectedUntil === null || selectedUntil === void 0 ? void 0 : selectedUntil.toDate()) || null;
      } else {
        newUntil = (prevSelectedUntil === null || prevSelectedUntil === void 0 ? void 0 : prevSelectedUntil.toDate()) || null;
      }

      if (rangeChanged) {
        onChange({
          from: newFrom,
          until: newUntil
        });
        setOpen(false);
      }
    } else if (!open) {
      setVisibleFrom(selectedFrom);
      setVisibleUntil(selectedUntil);
    }
  }, [onChange, open, prevSelectedFrom, prevSelectedUntil, selectedFrom, selectedUntil, visibleFrom, visibleUntil]);

  var handleChange = function handleChange(range) {
    var _range = _slicedToArray(range, 2),
        newFrom = _range[0],
        newUntil = _range[1];

    setVisibleFrom(newFrom);
    setVisibleUntil(newUntil);

    if (!enableTime) {
      setSelectedFrom(newFrom);
      setSelectedUntil(newUntil);
    }
  };

  var onRangeClick = function onRangeClick(range) {
    var _range2 = _slicedToArray(range, 2),
        newFrom = _range2[0],
        newUntil = _range2[1];

    setVisibleFrom(newFrom);
    setVisibleUntil(newUntil);
    setSelectedFrom(newFrom);
    setSelectedUntil(newUntil);
  };

  var isDateDisabled = function isDateDisabled(dateToCheck) {
    if (enabledDate) {
      return !enabledDate({
        minDate: minDate,
        maxDate: maxDate,
        timezone: timezone,
        from: visibleFrom === null || visibleFrom === void 0 ? void 0 : visibleFrom.toDate(),
        until: visibleUntil === null || visibleUntil === void 0 ? void 0 : visibleUntil.toDate(),
        dateToCheck: dateToCheck === null || dateToCheck === void 0 ? void 0 : dateToCheck.toDate()
      });
    }

    if (minDate && dateToCheck < _momentTimezone["default"].tz((0, _momentTimezone["default"])(minDate), timezone) || maxDate && dateToCheck > _momentTimezone["default"].tz((0, _momentTimezone["default"])(maxDate), timezone)) {
      return true;
    }

    return false;
  };

  var templates = rangeTemplates;

  if (enableRangeTemplates && rangeTemplates.length === 0) {
    var defaultRanges = (0, _rangeTemplates["default"])(locale, timezone);
    templates = Object.keys(defaultRanges).map(function (key) {
      return defaultRanges[key];
    });
  }

  var format = enableTime ? 'L LT' : 'L';
  var value = null;

  if (visibleFrom || visibleUntil) {
    value = [];

    if (visibleFrom) {
      value.push(visibleFrom.locale(locale).tz(timezone));
    }

    if (visibleUntil) {
      value.push(visibleUntil.locale(locale).tz(timezone));
    }
  }

  return /*#__PURE__*/_react["default"].createElement(_Picker["default"], {
    disabled: disabled,
    onOpenChange: setOpen,
    onChange: handleChange,
    open: open,
    value: value,
    calendar: /*#__PURE__*/_react["default"].createElement(_RangeCalendar["default"], {
      defaultValue: _momentTimezone["default"].tz((0, _momentTimezone["default"])().startOf('day'), timezone),
      onChange: handleChange,
      locale: _locales["default"][locale],
      momentLocale: locale,
      format: format,
      onOk: function onOk(range) {
        var _range3 = _slicedToArray(range, 2),
            newFrom = _range3[0],
            newUntil = _range3[1];

        setSelectedFrom(newFrom);
        setSelectedUntil(newUntil);
      },
      showOk: enableTime,
      showToday: false,
      disabledDate: isDateDisabled,
      renderFooter: function renderFooter() {
        return enableRangeTemplates ? /*#__PURE__*/_react["default"].createElement(_dateRangeFooter["default"], {
          rangeTemplates: templates,
          onRangeSelect: onRangeClick
        }) : null;
      },
      timePicker: enableTime ? /*#__PURE__*/_react["default"].createElement(_Panel["default"], {
        disableHours: isDateDisabled,
        disableMinutes: isDateDisabled,
        showSecond: false
      }) : null
    })
  }, function (_ref2) {
    var inputValue = _ref2.value;
    return !isFilterFlyOut ? /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiInput, {
      className: "w-80",
      label: inputLabel,
      hideLabel: hideLabel,
      disabled: disabled,
      readOnly: true,
      value: inputValue && "".concat((0, _momentTimezone["default"])(inputValue[0]).locale(locale).format(format), " - ").concat((0, _momentTimezone["default"])(inputValue[1]).locale(locale).format(format)) || ''
    }) : /*#__PURE__*/_react["default"].createElement("label", {
      className: "relative flex items-center text-primary"
    }, /*#__PURE__*/_react["default"].createElement("input", {
      // eslint-disable-next-line max-len
      className: "bg-gray-200 py-1 px-6 rounded outline-none flex-1 border-solid border-transparent border-b-2 focus:border-primary transition-colors duration-300",
      value: inputValue && "".concat((0, _momentTimezone["default"])(inputValue[0]).locale(locale).format(format), " - ").concat((0, _momentTimezone["default"])(inputValue[1]).locale(locale).format(format)) || ''
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "sr-only"
    }, inputLabel));
  });
};

DateRangePicker.propTypes = {
  isFilterFlyOut: _propTypes["default"].bool,
  timezone: _propTypes["default"].string,
  enableTime: _propTypes["default"].bool,
  enableRangeTemplates: _propTypes["default"].bool,
  rangeTemplates: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
  from: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].string]),
  until: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].string]),
  disabled: _propTypes["default"].bool,
  locale: _propTypes["default"].string,
  minDate: _propTypes["default"].string,
  maxDate: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  inputLabel: _propTypes["default"].node,
  hideLabel: _propTypes["default"].bool,
  enabledDate: _propTypes["default"].func
};

var noop = function noop() {};

exports.noop = noop;
DateRangePicker.defaultProps = {
  isFilterFlyOut: false,
  from: null,
  until: null,
  enabledDate: undefined,
  timezone: 'Europe/London',
  locale: 'en-GB',
  enableTime: false,
  enableRangeTemplates: false,
  rangeTemplates: [],
  disabled: false,
  minDate: undefined,
  maxDate: undefined,
  onChange: noop,
  inputLabel: null,
  hideLabel: false
};
var _default = DateRangePicker;
exports["default"] = _default;